export var MuiCard = {
    defaultProps: {
        variant: "outlined",
    },
    styleOverrides: {
        root: {
            borderRadius: 0,
        },
    },
};
